<script setup>
import { computed } from 'vue';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  option: {
    type: Object,
    default: () => {},
  },
  variant: {
    type: String,
    default: 'default',
  },
});

const isLucideIcon = computed(
  () => props.variant === 'icon' && props.option?.icon?.startsWith('i-')
);
</script>

<template>
  <div class="menu text-n-slate-12 min-h-7 min-w-0" role="button">
    <fluent-icon
      v-if="variant === 'icon' && option.icon && !isLucideIcon"
      :icon="option.icon"
      size="14"
      class="flex-shrink-0"
    />
    <span
      v-else-if="isLucideIcon"
      class="text-base flex-shrink-0 leading-none"
      :class="[option.icon]"
      aria-hidden="true"
    />
    <span
      v-if="variant === 'label' && option.color"
      class="label-pill flex-shrink-0"
      :style="{ backgroundColor: option.color }"
    />
    <Avatar
      v-if="variant === 'agent'"
      :name="option.label"
      :src="option.thumbnail"
      :status="option.status === 'online' ? option.status : null"
      :size="20"
      class="flex-shrink-0"
    />
    <p class="menu-label truncate min-w-0 flex-1">
      {{ option.label }}
    </p>
  </div>
</template>

<style scoped lang="scss">
.menu {
  width: calc(6.25rem * 2);
  @apply flex items-center flex-nowrap p-1 rounded-md overflow-hidden cursor-pointer;

  .menu-label {
    @apply my-0 mx-2 text-xs flex-shrink-0;
  }

  &:hover {
    @apply bg-n-brand text-white;
  }
}

.agent-thumbnail {
  margin-top: 0 !important;
}

.label-pill {
  @apply w-4 h-4 rounded-full border border-n-strong border-solid flex-shrink-0;
}
</style>
